export interface jobsProfileState {
  tabs: any[];
}

export const initialState: jobsProfileState = {
  tabs: [],
};
